import { useQuery } from '@tanstack/react-query';

import { apiErrorMessage } from '../../shared/api/errors';
import { formatBytes, formatDate } from '../../shared/lib/format';
import { ErrorText, Spinner } from '../../shared/ui/primitives';
import { listSoftware, softwareDownloadUrl, softwareQueryKey } from './api';

/** Ссылки на скачивание программы для просмотра снимков (Romexis). */
export function SoftwareList() {
  const query = useQuery({ queryKey: softwareQueryKey, queryFn: listSoftware });

  if (query.isLoading) return <Spinner />;
  if (query.isError) {
    return (
      <ErrorText>{apiErrorMessage(query.error, 'Не удалось загрузить список программ')}</ErrorText>
    );
  }
  if (!query.data || query.data.length === 0) {
    return null;
  }
  return (
    <ul className="space-y-2">
      {query.data.map((s) => (
        <li key={s.platform}>
          <a
            href={softwareDownloadUrl(s.platform)}
            className="flex items-center justify-between gap-3 rounded-lg border border-line px-4 py-3 hover:border-accent"
          >
            <span className="min-w-0">
              <span className="block text-sm font-medium text-ink">
                {s.title} для {s.platformLabel}
                {s.version && <span className="font-normal text-muted"> · версия {s.version}</span>}
              </span>
              <span className="block truncate text-xs text-muted">
                {s.fileName} · {formatBytes(s.size)} · обновлено {formatDate(s.updatedAt)}
              </span>
            </span>
            <span className="shrink-0 text-sm font-medium text-accent">Скачать</span>
          </a>
        </li>
      ))}
    </ul>
  );
}
